module.exports = __webpack_public_path__ + "static/media/share_icon.5aa6838e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/share_icon.svg
// module id = 328
// module chunks = 2